import React, { useEffect } from 'react';
import { AppContext } from '../../App';

const About = () => {
  const { addListeners } = React.useContext(AppContext);
  useEffect(() => {
    addListeners();
  }, []);

  return (
    <main id="main">
      <section className="d-flex align-items-center"></section>
      <section id="about" className="about">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <img src="assets/img/logo1.jpg" className="img-fluid" alt="" />
            </div>
            <div className="col-lg-6 pt-4 pt-lg-0 content">
              <h3>JLAB transforms your idea into the commercial product</h3>
              <p>
                Welcome to Jovanovski Laboratory (JLAB), your premier source for
                high-quality engineering services and products. We are dedicated
                to helping you turn your ideas into reality through our
                electronic, mechanical, and product design services, with a
                particular focus on delivering precise CNC machines.
              </p>
              <p>
                Founded in 2021 by the Jovanovski brothers, JLAB has a rich
                history of innovation that predates its official inception. In
                2014, our team had an idea to develop a dual-function machine
                for milling and 3D printing. After several years of development,
                the first version of the prototype was realized in 2016 with 3D
                printing functionality. A second prototype was launched in 2018,
                with significant improvements in performance, thanks to the
                detailed analysis and continuous development efforts of our
                team.
              </p>
              <p>
                Mechanical design, electronic control units, and firmware
                development for our prototypes were fully developed in JLAB.
                Over the years, our team has worked on many projects for
                industrial companies worldwide, which have enhanced our
                engineering and scientific abilities. In 2022, JLAB officially
                began the JLABsmartCNC project, supported by the Fund for
                Innovation and Technology Development, to develop a commercial
                version of our biggest product, the dual-function CNC machine.
              </p>
              <p>
                Our laboratory is equipped with sophisticated equipment to help
                us provide innovative, customized solutions and responsive
                service to each of our clients. We are committed to making a
                positive impact on our clients, employees, and the environment
                while enhancing the built environment. Our work has earned us a
                high repeat business ratio, which speaks to our unwavering
                dedication to our clients satisfaction.
              </p>
              <p>
                Thank you for considering Jovanovski Laboratory for your
                engineering needs.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section id="counts" className="counts">
        <div className="container">
          <div className="row counters">
            <div className="col-lg-3 col-6 text-center">
              <span
                data-purecounter-start="0"
                data-purecounter-end="55"
                data-purecounter-duration="1"
                className="purecounter"
              >
                55
              </span>
              <p>Clients</p>
            </div>

            <div className="col-lg-3 col-6 text-center">
              <span
                data-purecounter-start="0"
                data-purecounter-end="85"
                data-purecounter-duration="1"
                className="purecounter"
              >
                85
              </span>
              <p>Projects</p>
            </div>

            <div className="col-lg-3 col-6 text-center">
              <span
                data-purecounter-start="0"
                data-purecounter-end="9"
                data-purecounter-duration="1"
                className="purecounter"
              >
                9
              </span>
              <p>JLAB Brand Products</p>
            </div>

            <div className="col-lg-3 col-6 text-center">
              <span
                data-purecounter-start="0"
                data-purecounter-end="6"
                data-purecounter-duration="1"
                className="purecounter"
              >
                10
              </span>
              <p>Hard Workers</p>
            </div>
          </div>
        </div>
      </section>
      <br />
      <br />
      <br />
    </main>
  );
};

export default About;
